<app-language-select-item
	*ngFor="let language of languagesList"
	[class.selected]="activeLanguageName === language.name"
	[languageName]="language.name"
	[translateToEn]="language.translationToEn"
	(click)="setActiveLanguage(language)">
</app-language-select-item>
